const ReviewSectionTitle = () => {
  return (
    <div className="flex flex-col w-full pl-[5%] mb-4">
      <span className="mb-2 text-Subhead">담벼락</span>
      <span className="text-gray-100 text-Body3-M">
        자유롭게 전시회 이야기를 붙여보세요.
      </span>
    </div>
  );
};

export default ReviewSectionTitle;
